import React, {FC, useState} from 'react';
import {IoMdPaperPlane} from 'react-icons/io';
import {SubmitFieldConfig} from './TYPE_SubmitFieldConfig';
import {SubmitField} from './SubmitField';

const style = {
	submitForm: `flex flex-col gap-y-2   w-full`,
	submitFormButton: `flex justify-center items-center   p-2   text-whirlwindLightest hover:text-whirlwindLight   bg-whirlwindPrimary hover:bg-whirlwindPrimaryDark   rounded   opacity-90`,
	submitFormButtonDisabled: `flex justify-center items-center   p-2   text-whirlwindLight   bg-whirlwindDisabled   rounded   opacity-65`,
};

type SubmitFormProps = {
	fields: SubmitFieldConfig[];
	id: string;
	onSubmit?: () => Promise<void>;
	tailwindcss?: string;
};

export const SubmitForm: FC<SubmitFormProps> = ({
	fields,
	id,
	onSubmit,
	tailwindcss,
}) => {
	// Component variables
	const [buttonDisabled, setButtonDisabled] = useState(false);

	return (
		<form
			className={`${style.submitForm} ${tailwindcss ? tailwindcss : ''}`}
			data-test-id={`${id}_TEST`}
			id={id}
			onSubmit={async (event) => {
				event.preventDefault();
				setButtonDisabled(true);
				if (onSubmit) {
					await onSubmit();
					setButtonDisabled(false);
				}
			}}>
			{fields.map((field) => (
				<SubmitField
					fieldVal={field.fieldVal}
					id={field.id}
					isTextArea={field.isTextArea}
					key={field.id}
					maxLength={field.maxLength}
					onlyForMaster={field.onlyForMaster}
					placeholder={field.placeholder}
					setFieldVal={field.setFieldVal}
				/>
			))}
			<button
				className={
					buttonDisabled
						? style.submitFormButtonDisabled
						: style.submitFormButton
				}
				data-test-id={`${id}Submit_TEST`}
				disabled={buttonDisabled}
				type="submit">
				<IoMdPaperPlane size={40} />
			</button>
		</form>
	);
};
